import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import { SetLoginForm, AuthInfo } from '@app/models';
import { useErrorLoginObserver } from '@app/hooks';

import { UserSessionInfo } from '@app/models';
import { basicService } from '@app/services';
import { elevateSignin } from '@app/store/actions';

interface IProps {
    setLoginForm: SetLoginForm;
    userSessionInfo: UserSessionInfo;
    setAuthInfo: Dispatch<SetStateAction<AuthInfo>>;
}

export const SignInElevate: React.SFC<IProps> = ({ setLoginForm, setAuthInfo }) => {
    const currentUserId = useSelector((state: any) => state.signIn.currentUser.userUuid as string);

    const dispatch = useDispatch();
    useErrorLoginObserver(
        () => {},
        () => {},
        setLoginForm,
        setAuthInfo,
        () => {}
    );

    useEffect(() => {
        const methodsParam = decodeURIComponent(basicService.getQueryVariable('methods'));

        // on success we are taken back to launch page
        // on error, login observer handles flow
        dispatch(elevateSignin(currentUserId, methodsParam));
    }, []);

    return (
        <>
            <CircularProgress />
        </>
    );
};
